export default {"src":"/_next/static/media/PLD.725500fb.svg","height":18,"width":18};